import React, {Component} from 'react';
import auth0Client from '../Auth';
import axios from 'axios';
import {SERVER_URL}  from '../Constants';
import Cookies from 'universal-cookie';
import BootstrapTable from 'react-bootstrap-table-next';
import ToolkitProvider, { Search } from 'react-bootstrap-table2-toolkit';


const { SearchBar } = Search;




class SelectAccount extends Component {
    constructor(props) {
      super(props);
       this.state={
           venues:[],
           filteredVenues:[],
           loading:false,
           totalCount:0
       }
       this.rowEvents = {
        onClick: (e, row, rowIndex) => {
          this.rowSelect(row);         
        },
        
      };
  
    }
  
  async componentDidMount(){
   
   try{
     this.setState({loading:true});
        var me = (await axios.get(`${SERVER_URL}/me`,{headers: { 'Authorization': `Bearer ${auth0Client.getIdToken()}` }})).data;
        if (me && me.mappedVenues){
          me.mappedVenues.sort(function(a, b) {
            var nameA = a.name.toUpperCase(); // ignore upper and lowercase
            var nameB = b.name.toUpperCase(); // ignore upper and lowercase
            if (nameA < nameB) {
              return -1;
            }
            if (nameA > nameB) {
              return 1;
            }
  
            // names must be equal
            return 0;
          });
            this.setState({
                venues:me.mappedVenues,
                filteredVenues:me.mappedVenues,
                loading:false,
                totalCount:me.mappedVenues.length
            });
        
        }
   }catch(e){
        alert('Your session has ended, please Sign out and sign back in again');
        
   }finally{
    this.setState({loading:false});
   }


    }   

  handleCheck(e) {
   //alert(e.currentTarget.dataset.id);
   const cookies = new Cookies();
   const selectedVenueId = e.currentTarget.dataset.id;
   cookies.set('defaultVenueId', selectedVenueId, { path: '/' });
   auth0Client.setActiveVenueId(selectedVenueId);
   if (this.props.onCloseAndRefresh) { this.props.onCloseAndRefresh();}


 }

 rowSelect(row) {
  //alert(e.currentTarget.dataset.id);
  const cookies = new Cookies();
  const selectedVenueId = row.objectId;
  cookies.set('defaultVenueId', selectedVenueId, { path: '/' });
  auth0Client.setActiveVenueId(selectedVenueId);
  if (this.props.onCloseAndRefresh) { this.props.onCloseAndRefresh();}


}


  renderAccountsMenuItems=()=>{

   
     if (this.state.venues){
        // sort
        // sort by name
        this.state.venues.sort(function(a, b) {
          var nameA = a.name.toUpperCase(); // ignore upper and lowercase
          var nameB = b.name.toUpperCase(); // ignore upper and lowercase
          if (nameA < nameB) {
            return -1;
          }
          if (nameA > nameB) {
            return 1;
          }

          // names must be equal
          return 0;
        });
        const items = this.state.filteredVenues.map((item)=>
        <li data-id={item.objectId}  onClick={this.handleCheck.bind(this)} key={item.objectId} >
          <div className='row'>
            <div className='col-2'>
            <img style={{width: '35px', height:'30px'}} src={item.base64Icon} alt=''/>
            </div>
            <div className='col'>
            <p className="text-primary">{item.name} </p>
            </div>
           </div>
           <hr/>
          </li>); // add icon too
        return (
          <ul>{items}</ul>
        )
    }else{
      return (null);
    }
  }
  
  renderTable=()=>{
    return (

      <ToolkitProvider 
        bootstrap4
        keyField='objectId' 
        data={ this.state.venues } 
        columns={ this.getColumns()} 
        defaultSorted={[{
          dataField: 'name',
          order: 'asc'
        }]}
        search
        >
           {props => (
              <div>
                 <div className='row '>
                      <div className='col-3 text-center' >
                          <SearchBar { ...props.searchProps } />
                      </div>
                  </div>
                  <div className='row '>
                      <div className='col-12 text-right' style={{ height: '500px', overflow: 'scroll' }}>
                      <BootstrapTable
                        maxHeight={"200px"}                                            
                        style={{ height: '500px', overflow: 'scroll' }}
                      className="table-sm"
                      ref={this.tableRef}
                      striped
                      hover
                      condensed
                      rowEvents={this.rowEvents}
                      { ...props.baseProps }
                    
                      />
                       </div>

                  </div>
 

             

            </div>

          )}

    </ToolkitProvider>
    );
    
  }



  getColumns =()=>{
         
    let columns=[

     

        { dataField: 'base64Icon', editable:false, text: 'Picture', formatter: this.imageFormat,headerAlign: 'center', headerStyle: {width:'90px'}  },
        { dataField: 'name',editable:false,sort: true, classes:'text-primary',hidden:false, text: 'Name', headerAlign: 'center', headerStyle: {width:'350px'}, filterable:false,  align: 'center', },
        { dataField: 'shippingCity',editable:false, sort: true, classes:'text-primary',hidden:false, text: 'City', headerAlign: 'center', filterable:false,  align: 'center', },
        { dataField: 'shippingState',editable:false, sort: true, classes:'text-primary',hidden:false, text: 'State', headerAlign: 'center', filterable:false,  align: 'center', },

       // { dataField: '_id',classes:'text-primary',hidden:false, text: '', headerAlign: 'center',formatter:this.rowActions, filterable:false,  align: 'center', headerStyle: { width: '220px'} },
 
    ];
 return columns
}

imageFormat=(cell,row)=>{
  return (        
      <img style={{width: '35px', height:'30px'}} src={row.base64Icon} alt=''/>
  )
}

  
  filter=(filterValStr)=>{
    if (filterValStr){
    
      let filtered = this.state.venues.filter(function (venue) { return venue.name.toUpperCase().includes(filterValStr.toUpperCase())  });
      this.setState({
        filteredVenues:filtered
      })
    }else{
      //reset to original collection
      this.setState({
        filteredVenues:this.state.venues
      })
    }
  }
    
    render() {
  // <button className="btn btn-dark" onClick={() => {signIn()}}>Sign In</button>
    return (
        <div className='container'>
       
            <h4> Accounts</h4>
            <p>Click the account to make active. {this.state.totalCount} loaded.</p>
         
        
          <hr/>
           {(this.state.loading===true)?  "loading..." : ''}
               {
                  this.renderTable()
                  //this.renderAccountsMenuItems()
               }
            

            <br/><br/><br/>
        </div>
      

     


    )}

  }
  
  export default SelectAccount;